import React, { useState } from 'react';
import "../css/donations.css";
import { loadStripe } from '@stripe/stripe-js';
import Navbar from '../components/navbar';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import Footer from '../components/footer';
const stripePromise = loadStripe('pk_live_51PfpfKFMYGd90Udh4IKbT4XCIs2ueT2DGURpPHGaTJNZwFv6xU8EJ9QROJKtxLAa0AkzD7MZjYzqhYdStwEr8GGJ00RdauEC7V'); // Replace with your real Stripe public key

const handleDonate = async (amount, isRecurring) => {
    try {
        const stripe = await stripePromise;

        const response = await fetch(
            "https://us-central1-sole-15b6f.cloudfunctions.net/createStripeSession",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    amount: Number(amount.toString().replaceAll(',', '')) * 100,
                    recurring: isRecurring
                }) // convert to cents
            }
        );

        if (!response.ok) {
            let errorText = "";
            try {
                const maybeJson = await response.json();
                errorText = maybeJson?.error || JSON.stringify(maybeJson);
            } catch (_) {
                errorText = await response.text();
            }
            throw new Error(`Server error: ${response.status} - ${errorText}`);
        }

        const session = await response.json();
        console.log("Stripe session response:", session);
        if (!session || !session.url) {
            throw new Error("Invalid session URL returned from backend.");
        }

        console.log("Redirecting to Stripe Checkout URL:", session.url);
        window.location.href = session.url;
    } catch (error) {
        console.error("Stripe checkout error:", error);
        alert(error?.message || "Donation failed. Please try again later.");
    }
};

const Donations = () => {
    const [amount, setAmount] = useState('');
    const [isRecurring, setIsRecurring] = useState(false);
    const [selectedPreset, setSelectedPreset] = useState(null);

    return (
        <div className='donate-css'>
            <Helmet>
                <title>Support SOLE – GIVE</title>
                <meta name="description" content="Help form Catholic evangelists with a one-time or recurring gift." />

                {/* Open Graph */}
                <meta property="og:title" content="Support SOLE – Donate" />
                <meta property="og:description" content="Help form Catholic evangelists with a one-time or recurring gift." />
                <meta property="og:image" content="https://i.imgur.com/xDojFYF.png" />
                <meta property="og:url" content="https://soleministries.org/donate" />
                <meta property="og:type" content="website" />

                {/* Twitter preview */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Support SOLE – Donate" />
                <meta name="twitter:description" content="Help form Catholic evangelists with a one-time or recurring gift." />
                <meta name="twitter:image" content="https://i.imgur.com/xDojFYF.png" />
            </Helmet>
            <main>
                <Navbar />
                <div className="donate-page">
                    <h1>Support SOLE</h1>
                    <p>
                        Your donation helps us form and equip Catholic evangelists nationwide.
                        Servants of Our Lady of Evangelization is a registered 501(c)(3) nonprofit (EIN: 33-42127697),
                        and all contributions are tax-deductible to the fullest extent permitted by law.
                    </p>
                    <div className="stripe-form-placeholder">
                        <div className="preset-buttons">
                            {[10, 25, 50, 100].map((value) => (
                                <button
                                    key={value}
                                    className={`donate-button ${selectedPreset === value ? 'active' : ''}`}
                                    onClick={() => {
                                        setSelectedPreset(value);
                                        setAmount(value.toLocaleString('en-US'));
                                    }}
                                >
                                    Give ${value}
                                </button>
                            ))}
                        </div>
                        <p className="donation-instructions">
                            Prefer to give a different amount? Enter a custom donation below:
                        </p>
                        {/* Stripe donation form will be embedded here */}
                        {/* <label htmlFor="donation-amount" className="visually-hidden">Donation Amount</label> */}
                        <input
                            id="donation-amount"
                            type="text"
                            min="1"
                            placeholder="Enter amount in USD"
                            value={amount}
                            onChange={(e) => {
                                const raw = e.target.value.replace(/,/g, '').replace(/[^\d]/g, '');
                                if (raw === '') {
                                    setAmount('');
                                    return;
                                }
                                const numeric = parseInt(raw);
                                if (!isNaN(numeric)) {
                                    setAmount(numeric.toLocaleString('en-US'));
                                }
                            }}
                            className="donation-input"
                        />
                        <div className="recurring-option">
                            <input
                                type="checkbox"
                                id="recurring"
                                checked={isRecurring}
                                onChange={(e) => setIsRecurring(e.target.checked)}
                            />
                            <label htmlFor="recurring">Make this a monthly donation</label>
                        </div>
                        <button
                            className="donate-button"
                            onClick={() => {
                                handleDonate(amount, isRecurring);
                            }}
                        >
                            Donate
                        </button>
                        <p style={{ fontSize: '0.9rem', marginTop: '1rem' }}>
                            Questions? Email us at <a href="mailto:info@soleministries.org">info@soleministries.org</a>.
                        </p>
                        <p style={{ fontSize: '0.85rem', fontStyle: 'italic', marginTop: '0.5rem' }}>
                            SOLE is a registered nonprofit. No goods or services were provided in exchange for this donation.
                        </p>
                        <p style={{ fontSize: '0.95rem', marginTop: '1.5rem', textAlign: 'center' }}>
                            Want to support SOLE in another way?
                            <a href="/candle" style={{ color: '#1a4c8b', fontWeight: '600', textDecoration: 'none', marginLeft: '0.3rem' }}>
                                Purchase the Altar Flame candle.
                            </a>
                        </p>
                    </div>
                </div>
                <Footer />
            </main>
        </div>
    );
};

export default Donations;
